import { LightningElement, api, wire } from "lwc";
import { localizeNumber } from "@devforce/trailhead-client-locale";
import { LabelsAdapter } from "common/labelsAdapter";
import { attrToBool } from "common/helpers";
import { BREAKPOINT_WIDTHS } from "common/mediaQueryAdapter";
import horizontalTemplate from "./filters.html";
import verticalTemplate from "./filtersVertical.html";
import { c as classNames } from "tds/chunk_index";

var data$9 = {
  close: "Schließen",
  drawer_button_with_count: "%{count} Ergebnisse anzeigen",
  drawer_button: "Ergebnisse anzeigen",
  drawer_heading_filter: "Filtern",
  drawer_heading_sort: "Sortieren",
  drawer_subheading_with_count: "(%{count}) Ergebnisse",
  drawer_trigger: "Weitere Filter",
  filter_value: "%{count} ausgewählt",
  filter: "Filtern",
  reset: "Alle löschen",
  sort: "Sortieren",
};
data$9.close;
data$9.drawer_button_with_count;
data$9.drawer_button;
data$9.drawer_heading_filter;
data$9.drawer_heading_sort;
data$9.drawer_subheading_with_count;
data$9.drawer_trigger;
data$9.filter_value;
data$9.filter;
data$9.reset;
data$9.sort;

var data$8 = {
  close: "Close",
  drawer_button_with_count: "View %{count} results",
  drawer_button: "View results",
  drawer_heading_filter: "Filter",
  drawer_heading_sort: "Sort",
  drawer_subheading_with_count: "(%{count}) results",
  drawer_trigger: "More filters",
  filter_value: "%{count} selected",
  filter: "Filter",
  reset: "Clear all",
  sort: "Sort",
};
data$8.close;
data$8.drawer_button_with_count;
data$8.drawer_button;
data$8.drawer_heading_filter;
data$8.drawer_heading_sort;
data$8.drawer_subheading_with_count;
data$8.drawer_trigger;
data$8.filter_value;
data$8.filter;
data$8.reset;
data$8.sort;

var data$7 = {
  close: "Cerrar",
  drawer_button_with_count: "Ver %{count} resultados",
  drawer_button: "Ver resultados",
  drawer_heading_filter: "Filtro",
  drawer_heading_sort: "Ordenar",
  drawer_subheading_with_count: "(%{count}) resultados",
  drawer_trigger: "Más filtros",
  filter_value: "%{count} seleccionado",
  filter: "Filtro",
  reset: "Borrar todo",
  sort: "Ordenar",
};
data$7.close;
data$7.drawer_button_with_count;
data$7.drawer_button;
data$7.drawer_heading_filter;
data$7.drawer_heading_sort;
data$7.drawer_subheading_with_count;
data$7.drawer_trigger;
data$7.filter_value;
data$7.filter;
data$7.reset;
data$7.sort;

var data$6 = {
  close: "Cerrar",
  drawer_button_with_count: "Ver %{count} resultados",
  drawer_button: "Ver resultados",
  drawer_heading_filter: "Filtrar",
  drawer_heading_sort: "Ordenar",
  drawer_subheading_with_count: "(%{count}) resultados",
  drawer_trigger: "Más filtros",
  filter_value: "%{count} seleccionado",
  filter: "Filtrar",
  reset: "Borrar todo",
  sort: "Ordenar",
};
data$6.close;
data$6.drawer_button_with_count;
data$6.drawer_button;
data$6.drawer_heading_filter;
data$6.drawer_heading_sort;
data$6.drawer_subheading_with_count;
data$6.drawer_trigger;
data$6.filter_value;
data$6.filter;
data$6.reset;
data$6.sort;

var data$5 = {
  close: "Fermer",
  drawer_button_with_count: "Afficher %{count} résultat(s)",
  drawer_button: "Afficher les résultats",
  drawer_heading_filter: "Filtre",
  drawer_heading_sort: "Tri",
  drawer_subheading_with_count: "(%{count}) résultats",
  drawer_trigger: "Plus de filtres",
  filter_value: "%{count} sélectionné(s)",
  filter: "Filtre",
  reset: "Effacer tout",
  sort: "Tri",
};
data$5.close;
data$5.drawer_button_with_count;
data$5.drawer_button;
data$5.drawer_heading_filter;
data$5.drawer_heading_sort;
data$5.drawer_subheading_with_count;
data$5.drawer_trigger;
data$5.filter_value;
data$5.filter;
data$5.reset;
data$5.sort;

var data$4 = {
  close: "Chiudi",
  drawer_button_with_count: "Visualizza %{count} risultati",
  drawer_button: "Visualizza risultati",
  drawer_heading_filter: "Filtra",
  drawer_heading_sort: "Ordina",
  drawer_subheading_with_count: "(%{count}) risultati",
  drawer_trigger: "Altri filtri",
  filter_value: "%{count} selezionati",
  filter: "Filtra",
  reset: "Cancella tutto",
  sort: "Ordina",
};
data$4.close;
data$4.drawer_button_with_count;
data$4.drawer_button;
data$4.drawer_heading_filter;
data$4.drawer_heading_sort;
data$4.drawer_subheading_with_count;
data$4.drawer_trigger;
data$4.filter_value;
data$4.filter;
data$4.reset;
data$4.sort;

var data$3 = {
  close: "閉じる",
  drawer_button_with_count: "%{count} 件の結果を表示",
  drawer_button: "結果を表示",
  drawer_heading_filter: "検索条件",
  drawer_heading_sort: "並び替え",
  drawer_subheading_with_count: "(%{count}) 件の結果",
  drawer_trigger: "その他の検索条件",
  filter_value: "%{count} 件が選択されています",
  filter: "検索条件",
  reset: "すべてクリア",
  sort: "並び替え",
};
data$3.close;
data$3.drawer_button_with_count;
data$3.drawer_button;
data$3.drawer_heading_filter;
data$3.drawer_heading_sort;
data$3.drawer_subheading_with_count;
data$3.drawer_trigger;
data$3.filter_value;
data$3.filter;
data$3.reset;
data$3.sort;

var data$2 = {
  close: "닫기",
  drawer_button_with_count: "결과 %{count}개 보기",
  drawer_button: "결과 보기",
  drawer_heading_filter: "필터",
  drawer_heading_sort: "정렬",
  drawer_subheading_with_count: "결과 (%{count}개)",
  drawer_trigger: "필터 더 보기",
  filter_value: "%{count}개 선택됨",
  filter: "필터",
  reset: "모두 지우기",
  sort: "정렬",
};
data$2.close;
data$2.drawer_button_with_count;
data$2.drawer_button;
data$2.drawer_heading_filter;
data$2.drawer_heading_sort;
data$2.drawer_subheading_with_count;
data$2.drawer_trigger;
data$2.filter_value;
data$2.filter;
data$2.reset;
data$2.sort;

var data$1 = {
  close: "Fechar",
  drawer_button_with_count: "Exibir %{count} resultado(s)",
  drawer_button: "Exibir resultados.",
  drawer_heading_filter: "Filtrar",
  drawer_heading_sort: "Classificar",
  drawer_subheading_with_count: "(%{count}) resultado(s)",
  drawer_trigger: "Mais filtros",
  filter_value: "%{count} selecionado(s)",
  filter: "Filtrar",
  reset: "Limpar tudo",
  sort: "Classificar",
};
data$1.close;
data$1.drawer_button_with_count;
data$1.drawer_button;
data$1.drawer_heading_filter;
data$1.drawer_heading_sort;
data$1.drawer_subheading_with_count;
data$1.drawer_trigger;
data$1.filter_value;
data$1.filter;
data$1.reset;
data$1.sort;

var data = {
  close: "关闭",
  drawer_button_with_count: "查看 %{count} 个结果",
  drawer_button: "查看结果",
  drawer_heading_filter: "筛选器",
  drawer_heading_sort: "排序",
  drawer_subheading_with_count: "(%{count}) 个结果",
  drawer_trigger: "更多筛选器",
  filter_value: "已选择 %{count} 个",
  filter: "筛选器",
  reset: "全部清除",
  sort: "排序",
};
data.close;
data.drawer_button_with_count;
data.drawer_button;
data.drawer_heading_filter;
data.drawer_heading_sort;
data.drawer_subheading_with_count;
data.drawer_trigger;
data.filter_value;
data.filter;
data.reset;
data.sort;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

// Changes to these values must be synced with CSS media queries.
const BREAKPOINT = BREAKPOINT_WIDTHS.md; // 48rem = 48 * 16px = 768px
const DEFAULT_CONTROL_WIDTH = 8 + 180 + 8; // width + gutters

const config = {
  horizontal: {
    breakpoint: BREAKPOINT,
    template: horizontalTemplate,
  },
  vertical: {
    breakpoint: BREAKPOINT_WIDTHS.md,
    template: verticalTemplate,
  },
};

// Map that tells which form control types are closeable. This is
// used to decide whether to dispatch the "filter" event for
// non-closeable controls immediately so consumers can handle it.
const closeableFormControls = new Map();
closeableFormControls.set("combobox", true);
function isCloseableControl(type) {
  return !!closeableFormControls.get(type);
}
class filters extends LightningElement {
  @api filters = null;
  @api sort = null;
  @api resultCount = null;
  @api busy = false;
  @api direction = "horizontal";
  @api isSetup = false;
  @api threshold = 1;
  isDrawerClosed = true;
  isFilterMode = false;
  isSortMode = false;
  filterEvent = null;
  filterQueue = [];
  focusFirstFilterControl = false;
  stencilLength = 4;
  get isBusy() {
    return attrToBool(this.busy);
  }
  get isVertical() {
    return this.direction === "vertical";
  }
  get visibleFilters() {
    return this.filters
      ? this.filters.filter((f, i) => i < this.threshold)
      : [];
  }
  get drawerFilters() {
    return this.filters
      ? this.filters.map((f) => {
          if (f.type === "combobox") {
            return {
              ...f,
              variant: "accordion",
            };
          }
          return f;
        })
      : [];
  }
  get hiddenFilters() {
    return this.filters
      ? this.filters.filter((f, i) => i >= this.threshold)
      : [];
  }
  get formattedResultCount() {
    return this.resultCount ? localizeNumber(this.resultCount) : 0;
  }
  get sortConfig() {
    return {
      toggleDisabled: true,
      ...this.sort,
    };
  }
  @wire(LabelsAdapter, {
    locales,
    options: "$labelOptions",
  })
  _labels = null;
  get labels() {
    return {
      ...this._labels,
      drawer_button:
        this.resultCount != null
          ? this._labels.drawer_button_with_count
          : this._labels.drawer_button,
      drawer_heading: this.isSortMode
        ? this._labels.drawer_heading_sort
        : this._labels.drawer_heading_filter,
      drawer_subHeading:
        this.resultCount != null
          ? this._labels.drawer_subheading_with_count
          : null,
      sort_value: this.sortValueLabel,
      visible_filter_value: this.isVisiblePillsEmpty
        ? null
        : `(${this.labelOptions.filter_value.count})`,
    };
  }
  get visiblePills() {
    return (
      this.filters?.filter((f) => f.value !== null && f.value !== undefined) ??
      []
    );
  }
  get isVisiblePillsEmpty() {
    return this.visiblePills.length == 0;
  }
  get labelOptions() {
    return {
      drawer_button_with_count: {
        count: this.formattedResultCount,
      },
      drawer_subheading_with_count: {
        count: this.formattedResultCount,
      },
      filter_value: {
        count: this.visiblePills.length,
      },
    };
  }
  connectedCallback() {
    window.addEventListener("resize", this.handleWindowResize);
  }
  renderedCallback() {
    this.queueDetectOverflow();
    if (this.isVisiblePillsEmpty && this.focusFirstFilterControl) {
      if (this.firstFilterControl) this.firstFilterControl.focus();
      this.focusFirstFilterControl = false;
    }
  }
  disconnectedCallback() {
    window.removeEventListener("resize", this.handleWindowResize);
  }
  render() {
    return config[this.direction].template;
  }
  handleFilterPills(event) {
    const removingLastPill = this.visiblePills.length === 1;
    if (removingLastPill) this.focusFirstFilterControl = true;
    this.dispatchEvent(
      new CustomEvent(event.type, {
        detail: event.detail,
      })
    );
  }

  // Width to use as divisor when determining how many controls overflow into drawer
  get baseControlWidth() {
    const el = this.template.querySelector(
      // Use last control because it has extra margin
      ".controls__container .form-control:last-of-type"
    );
    if (!el) {
      return DEFAULT_CONTROL_WIDTH;
    }
    const { minWidth, marginRight, marginLeft } = getComputedStyle(el);
    return parseInt(minWidth) + parseInt(marginRight) + parseInt(marginLeft);
  }
  get hasDrawer() {
    return !!(this.hiddenFilters && this.hiddenFilters.length);
  }
  get isDrawerButtonHidden() {
    return !this.hasDrawer;
  }
  get sortValueLabel() {
    if (!this.sort) {
      return "";
    }
    const option = this.sort.options.find((o) => o.value === this.sort.value);
    return option ? option.label : "";
  }
  queueDetectOverflow() {
    requestAnimationFrame(this.detectOverflow.bind(this));
  }
  get breakpoint() {
    // Vertical filters  only breakpoints for small FF. Values must be kept in
    // sync with stylesheet media queries.
    return config[this.direction].breakpoint;
  }

  // Put overflowing filters into the drawer
  detectOverflow() {
    // Return early if screen is small
    if (window.innerWidth <= this.breakpoint) {
      this.threshold = 0;
      return;
    }

    // When filters render vertically there's no overflow into drawer.
    if (this.isVertical) {
      this.threshold = Number.POSITIVE_INFINITY;
      return;
    }

    // If the threshold is set via @apiuse it directly
    if (this.threshold === Number.POSITIVE_INFINITY) {
      return;
    }
    try {
      // container width - sort width - button width
      const btnStyles = getComputedStyle(
        this.template.querySelector(".controls__drawer-button")
      );
      const availableWidth =
        this.template.host.offsetWidth -
        this.template.querySelector(".form-control:not(.form-control--sort)")
          .offsetLeft -
        parseInt(btnStyles.width) +
        parseInt(btnStyles.marginLeft);

      // Determine how many controls to show, but always show at least one
      this.threshold = Math.max(
        1,
        Math.floor(availableWidth / this.baseControlWidth)
      );
    } catch (error) {
      this.threshold = 1;
    }
  }
  handleFilter(e) {
    this.filterEvent = e;
    this.filterQueue.push(this.filterEvent);

    // If the control is not closeable, process the filter queue immediately.
    const formControl = e.currentTarget;
    if (!isCloseableControl(formControl.config.type)) {
      this.processFilterQueue();
    }
  }
  handleClose() {
    if (this.filterEvent) {
      this.dispatchEvent(new CustomEvent("filter", this.filterEvent));
    }
    this.filterEvent = null;
    this.filterQueue.length = 0;
  }
  get drawerClass() {
    return classNames("drawer", this.isDrawerClosed && "drawer--hidden");
  }
  handleSort(e) {
    this.dispatchEvent(new CustomEvent("sort", e));
  }
  handleSortVertical(e) {
    this.dispatchEvent(
      new CustomEvent("sort", {
        detail: {
          value: e.detail,
        },
      })
    );
  }
  handleReset() {
    this.dispatchEvent(new CustomEvent("reset"));
    this.focusFirstFilterControl = true;
  }
  handleWindowResize = () => {
    this.queueDetectOverflow();
    if (!this.hasDrawer) {
      this.isDrawerClosed = true;
    }
  };
  openDrawer() {
    this.isDrawerClosed = false;
    document.body.style.overflow = "hidden";
  }
  openFilterDrawer() {
    this.isFilterMode = true;
    this.openDrawer();
  }
  openSortDrawer() {
    this.isSortMode = true;
    this.openDrawer();
  }
  closeDrawer() {
    this.isDrawerClosed = true;
    document.body.style.overflow = "";
    this.processFilterQueue();
  }

  /**
   * Empties the filter queue dispatching each event in it.
   */
  processFilterQueue() {
    while (this.filterQueue.length > 0) {
      const event = this.filterQueue.shift();
      this.dispatchEvent(new CustomEvent("filter", event));
    }
  }
  resetDrawer() {
    if (this.isDrawerClosed) {
      this.isFilterMode = false;
      this.isSortMode = false;
    }
  }
  get firstFilterControl() {
    return this.template.querySelector(
      ".form-control:not(.form-control--sort)"
    );
  }
  get stencils() {
    return Array.from({
      length: this.stencilLength,
    }).map((_, i) => ({
      key: `stencil-${i}`,
    }));
  }
}

export default filters;
export { BREAKPOINT, DEFAULT_CONTROL_WIDTH };
